var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1311_332)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1311_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.15002 21C-3.15002 23.954 -2.61863 26.7837 -1.64791 29.3999L21 31.4999L43.6479 29.3999C44.6186 26.7837 45.15 23.954 45.15 21C45.15 18.0459 44.6186 15.2162 43.6479 12.6L21 10.5L-1.64791 12.6C-2.61863 15.2162 -3.15002 18.0459 -3.15002 21V21Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6478 12.6C40.2356 3.40378 31.3836 -3.15002 20.9999 -3.15002C10.6163 -3.15002 1.76428 3.40378 -1.64795 12.6H43.6478Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.64795 29.3999C1.76428 38.5961 10.6163 45.1499 20.9999 45.1499C31.3836 45.1499 40.2356 38.5961 43.6478 29.3999H-1.64795Z",
    fill: "#D80027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1311_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 16.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1311_332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.15002 21C-3.15002 7.6623 7.6623 -3.15002 21 -3.15002V-3.15002C34.3377 -3.15002 45.15 7.6623 45.15 21V21C45.15 34.3377 34.3377 45.15 21 45.15V45.15C7.6623 45.15 -3.15002 34.3377 -3.15002 21V21Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsFlag);
export default __webpack_public_path__ + "static/media/es-flag.62069dac445105f51af54f246cf760ef.svg";
export { ForwardRef as ReactComponent };